/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RansomwareProxyActivationSpec { 
    /**
     * Org id
     */
    org_id: string;
    /**
     * Carbon Black PoP ID
     */
    cb_pop_id: string;
    /**
     * Requester Email Address
     */
    requester_email: string;
    /**
     * Requester first name
     */
    requester_first_name: string;
    /**
     * Requester last name
     */
    requester_last_name: string;
}

